import { AfterViewInit, Component, NgZone, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment'

declare var $: any

@Component({
	selector: 'my-categories-courses',
	templateUrl: './my-categories-courses.component.html',
	styleUrls: ['./my-categories-courses.component.scss']
})

export class MyCategoriesCoursesComponent implements OnInit, AfterViewInit, OnDestroy {

	userID = 0
	userName = ''
	userOrg = 0

	userRole = 0
	roleSystemAdmin = false
	roleOrgAdmin = false
	roleEditor = false
	roleViewer = false

	welcome = true
	search = false
	courseSearchTerm = ''

	duplicate = false
	duplicateNodeId = 0
	duplicateNodeName = ''
	duplicateNodeType = ''
	duplicateNodeParent = 0

	courseFormCategoryID = 0
	courseFormCategoryName = 0

	usersAdmin = false
	userCoursePermissionsAdmin = false
	orgsAdmin = false
	usersRole = 0
	usersOrg = 0
	usersSearchTerm = ''
	users: any[] = []
	orgs: any[] = []
	roles: any[] = []
	userCoursePermissions: any[] = []

	jsTree: any = $.jstree!
	treeDataUrl = ''

	getOrgsSub = new Subscription
	getRolesSub = new Subscription
	getUsersSub = new Subscription
	getUserCoursePermissionsSub = new Subscription
	searchSub = new Subscription
	duplicateCourseSub = new Subscription
	editUserSub = new Subscription
	deleteUserSub = new Subscription
	editOrgSub = new Subscription
	deleteOrgSub = new Subscription
	insertNodeSub = new Subscription
	moveNodeSub = new Subscription
	editNodeSub = new Subscription
	deleteNodeSub = new Subscription

	constructor(private dataService: ApiService, private router: Router, private zone: NgZone) { }

	ngOnInit(): void {
		this.userID = this.dataService.getUserID()
		this.userName = this.dataService.getUserName()
		this.userOrg = this.dataService.getUserOrg()

		this.userRole = this.dataService.getUserRole()
		this.roleSystemAdmin = this.userRole === 1
		this.roleOrgAdmin = this.userRole === 2
		this.roleEditor = this.userRole === 3
		this.roleViewer = this.userRole === 4

		document.title = `${environment.title}: Mis cursos`

		this.getOrgsSub = this.dataService.getOrganizations()
		.subscribe({
			next: orgs => {
				this.orgs = orgs
			},
			error: e => {
				console.log(e)
			},
		})

		this.getRolesSub = this.dataService.getRoles()
		.subscribe({
			next: roles => {
				this.roles = roles
			},
			error: e => {
				console.log(e)
			},
		})

		this.treeDataUrl = `${this.dataService.baseUrl}/php/common/tree/categories_nodes.php`
	}

	ngAfterViewInit(): void {
		this.zone.runOutsideAngular(() => {
			$(() => {
				let jstree: any = $('#jstree')

				// Icons
				let folderIcon = 'fas fa-folder me-2'
				let folderOpenIcon = 'fas fa-folder-open me-2'
				let folderAddIcon = 'fas fa-folder-plus me-2'
				let graduationCapIcon = 'fas fa-graduation-cap me-2'
				let circlePlusIcon = 'fas fa-circle-plus text-success me-2'
				let editIcon = 'fas fa-edit me-2'
				let copyIcon = 'far fa-copy me-2'
				let trashCanIcon = 'fas fa-trash-can text-danger me-2'

				let folderAddIconHtml = 
				`<span class="fa-layers ms-4 me-2">
              		<i class="${folderIcon}" data-fa-transform="grow-4"></i>
              		<i class="${circlePlusIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
				let folderEditIconHtml =
					`<span class="fa-layers ms-4 me-2">
              		<i class="${folderIcon}" data-fa-transform="grow-4"></i>
              		<i class="${editIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
				let folderDeleteIconHtml =
					`<span class="fa-layers ms-4 me-2">
              		<i class="${folderIcon}" data-fa-transform="grow-4"></i>
              		<i class="${trashCanIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
				let courseAddIconHtml =
					`<span class="fa-layers ms-4 me-2">
              		<i class="${graduationCapIcon}" data-fa-transform="grow-4"></i>
              		<i class="${circlePlusIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
				let courseEditIconHtml =
					`<span class="fa-layers ms-4 me-2">
              		<i class="${graduationCapIcon}" data-fa-transform="grow-4"></i>
              		<i class="${editIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
				let courseDeleteIconHtml =
					`<span class="fa-layers ms-4 me-2">
              		<i class="${graduationCapIcon}" data-fa-transform="grow-4"></i>
              		<i class="${trashCanIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
				let courseDuplicateIconHtml =
					`<span class="fa-layers ms-4 me-2">
              		<i class="${graduationCapIcon}" data-fa-transform="grow-4"></i>
              		<i class="${copyIcon}" data-fa-transform="shrink-2 down-12 right-12"></i>
            	</span>`
	
				jstree.jstree({
					'core': {
						'check_callback': true,
						'multiple': false,
						'strings': {
							'Loading ...': 'Cargando ...'
						},
						'themes': {
							'name': 'default',
						},
						'data': {
							'dataType': 'json',
							'url': this.treeDataUrl,
							'data': (_node: any) => {
								// console.log(node)
								return {
									'user': this.userID,
								}
							}
						}
					},
					'search': {
						'show_only_matches': true,
					},
					'contextmenu': {
						'select_node': true,
						'show_at_node': false,
						'items': (node: any) => {
							let categoryItems = {
								addCategory: {
									label: folderAddIconHtml + '<span>Crear nuevo certificado</span>',
									action: () => {
										console.log(node)
										let position = +node.original.position + 1
										let newNodeData = {
											'text': 'CERTIFICADO ',
											'type': 'category',
										}

										jstree.jstree('create_node', '#', newNodeData, position, (node: any) => {
											jstree.jstree('edit', `${node.id}`, undefined, (node: any, _status: any, cancelled: any) => {
												if (!cancelled) this.insertNode(node, position)
												else this.jstreeUpdate()
											})
										})
									},
								},
								addCourse: {
									label: courseAddIconHtml + '<span>Crear nuevo curso</span>',
									action: () => {
										this.courseFormCategoryID = +node.id.split('_').pop()
										this.zone.run(() => {
											let courseFormDialog = document.getElementById('course-form-dialog') as HTMLDialogElement
											courseFormDialog.showModal()
										})
									}
								},
								editCategory: {
									label: folderEditIconHtml + '<span>Editar certificado</span>',
									action: () => {
										jstree.jstree('edit', `${node.id}`, null, (node: any, _status: any, cancelled: any) => {
											if (!cancelled) this.editNode(node)
											else this.jstreeUpdate()
										})
									}
								},
								deleteCategory: {
									label: folderDeleteIconHtml + '<span>Eliminar certificado</span>',
									action: () => {
										Swal.fire({
											title: '¿Seguro?',
											text: '¿Está seguro que quiere borrar este certificado? Se borrarán todos los cursos asociados.',
											icon: 'question',
											showCancelButton: true,
											cancelButtonText: 'Cancelar'
										}).then((result) => {
											// console.log(result)
											if (result.isConfirmed) this.deleteNode(node)
										})
									}
								}
							}

							let courseItems = {
								addCourse: {
									label: courseAddIconHtml + '<span>Crear nuevo curso</span>',
									action: () => {
										this.courseFormCategoryID = +node.parent.split('_').pop()
										this.zone.run(() => {
											let courseFormDialog = document.getElementById('course-form-dialog') as HTMLDialogElement
											courseFormDialog.showModal()
										})
									}
								},
								editCourse: {
									label: courseEditIconHtml + '<span>Editar curso</span>',
									action: () => {
										jstree.jstree('edit', `${node.id}`, null, (node: any, _status: any, cancelled: any) => {
											if (!cancelled) this.editNode(node)
											else this.jstreeUpdate()
										})
									}
								},
								deleteCourse: {
									label: courseDeleteIconHtml + '<span>Eliminar curso</span>',
									action: () => {
										Swal.fire({
											title: '¿Seguro?',
											text: '¿Está seguro que quiere borrar este curso? Se borrará todo su contenido (lecciones, enunciados, multimedia, etc.).',
											icon: 'question',
											showCancelButton: true,
											cancelButtonText: 'Cancelar'
										}).then((result) => {
											// console.log(result)
											if (result.isConfirmed) this.deleteNode(node)
										})
									}
								},
								duplicateCourse: {
									label: courseDuplicateIconHtml + '<span>Duplicar curso</span>',
									action: () => {
										console.log(node)
										let id = +node.id.split('_').pop()
										let name = node.text.trim()
										let parent = +node.parent.split('_').pop()
										this.zone.run(() => {
											this.showDuplicate('course', id, name, parent)
										})
									},
								}
							}

							// console.log(node)
							let items = {}
							if (node.type === 'category') items = categoryItems
							else if (node.type === 'course') items = courseItems

							return items
						}
					},
					'dnd': {
						'copy': false,
						'drag_selection': false,
						'large_drop_target': true,
						'large_drag_target': true,
						'open_timeout': 100,
						'is_draggable': true,
					},
					'state': {
						'key': 'jstree_categories'
					},
					'types': {
						'#': {
							'max_depth': 2,
							'valid_children': ['category', 'category_create'],
						},
						'category': {
							'icon': folderIcon,
							'max_depth': 1,
							'valid_children': ['course', 'course_create'],
						},
						'course': {
							'icon': graduationCapIcon,
							'valid_children': false,
						},
						'category_create': {
							'icon': folderAddIcon,
							'valid_children': false,
						},
						'course_create': {
							// 'icon': graduationCapIcon,
							'icon': circlePlusIcon,
							'valid_children': false,
						},
						'course_generate': {
							// 'icon': graduationCapIcon,
							'icon': circlePlusIcon,
							'valid_children': false,
						},
					},
					'plugins': ['contextmenu', 'dnd', 'search', 'state', 'types', 'wholerow']
				})
	
				jstree.on('changed.jstree', (_e: any, data: any) => {
					let node = data.node
					if (node != undefined) console.log(node)
				})

				jstree.on('rename_node.jstree', (_e: any, data: any) => {
					// console.log(data)
					let node = data.node
					let id = node.id
					let newText = data.text.trim()
					let oldText = data.old.trim()
					let rename = newText != oldText && id != "j1_1"

					if (rename) this.editNode(node)
					else this.jstreeUpdate()
				})
				
				jstree.on('dblclick.jstree', (e: any) => {
					let node = jstree.jstree(true).get_node(e.target.parentElement)
					if (node == undefined) return
	
					let text = node.text
					let type = node.type
					let id = +node.id.split('_').pop()
	
					if (type == 'category_create') {
						this.zone.run(() => {
							// console.log(node)
							let position = +node.original.position
							let newNodeData = {
								'text': 'CERTIFICADO ',
								'type': 'category',
							}

							jstree.jstree('create_node', '#', newNodeData, position, (node: any) => {
								jstree.jstree('edit', `${node.id}`, undefined, (node: any, _status: any, cancelled: any) => {
									if (!cancelled) this.insertNode(node, position)
									else this.jstreeUpdate()
								})
							})
						})
					} else if (type == 'course_create') {
						this.courseFormCategoryID = +node.parent.split('_').pop()
						this.courseFormCategoryName = jstree.jstree(true).get_node(node.parent).text
						this.zone.run(() => {
							let courseFormDialog = document.getElementById('course-form-dialog') as HTMLDialogElement
							courseFormDialog.showModal()
						})
					} else if (type == 'course_generate') {
						this.courseFormCategoryID = +node.parent.split('_').pop()
						this.courseFormCategoryName = jstree.jstree(true).get_node(node.parent).text
						this.zone.run(() => {
							let generateCourseDialog = document.getElementById('generate-course-dialog') as HTMLDialogElement
							generateCourseDialog.showModal()
						})
					} else if (type == 'course') {
						this.zone.run(() => {
							this.dataService.setCourseID(id)
							this.dataService.setCourseName(text)
							this.router.navigate(['course', id])
						})
					}
	
					return
				})

				jstree.on('search.jstree', (_e: any, data: any) => {
					let matches = data.res.length
					if (matches == 0) {
						Swal.fire('Error', 'No se ha encontrado ningún curso. Intenta otra búsqueda con otras palabras.', 'error')
						this.clearSearch()
					}
				})

				jstree.on('move_node.jstree', (_e: any, data: any) => {
					let node = data.node
					let type = node.original.type
					let parentType = ''
					if (type == 'course') parentType = 'category'
					let oldPosition = data.old_position
					let oldParent = data.old_parent.split('_').pop()
					let newPosition = data.position
					let newParent = data.parent.split('_').pop()
	
					// console.log(node)
					// console.log(type)
					// console.log(oldPosition)
					// console.log(oldParent)
					// console.log(newPosition)
					// console.log(newParent)
	
					if (oldParent === newParent && oldPosition === newPosition) return
					// if (oldParent === '#') oldParent = this.courseID
					// if (newParent === '#') newParent = this.courseID
					this.moveNode(node, oldPosition, oldParent, newPosition, newParent)
				})
	
				jstree.on('before_open.jstree', (_e: any, data: any) => {
					data.instance.set_icon(data.node, folderOpenIcon)
				})
	
				jstree.on('close_node.jstree', (_e: any, data: any) => {
					data.instance.set_icon(data.node, folderIcon)
				})
			})
		})
	}

	ngOnDestroy(): void {
		this.getOrgsSub?.unsubscribe()
		this.getRolesSub?.unsubscribe()
		this.getUsersSub?.unsubscribe()
		this.getUserCoursePermissionsSub?.unsubscribe()
		this.searchSub?.unsubscribe()
		this.duplicateCourseSub?.unsubscribe()
		this.editUserSub?.unsubscribe()
		this.deleteUserSub?.unsubscribe()
		this.insertNodeSub?.unsubscribe()
		this.moveNodeSub?.unsubscribe()
		this.editNodeSub?.unsubscribe()
		this.deleteNodeSub?.unsubscribe()
	}

	insertNode(node: any, position: number, parent: number = 0) {
		console.log(node)
		let name = node.text
		let type = node.type

		this.insertNodeSub = this.dataService.insertNode(name, type, position, parent)
		.subscribe(
			(id: any) => {
				console.log(id)
				console.log(node)
				this.jstreeUpdate()
			},
			(error: any) => {
				console.log(error)
				Swal.fire('Error', 'No se ha podido insertar el nodo. Por favor, inténtelo de nuevo.', 'error')
			},
		)
	}

	moveNode(node: any, oldPosition: number, oldParent: number, newPosition: number, newParent: number) {
		let type = node.type
		let id = +node.id.split('_').pop()

		this.moveNodeSub = this.dataService.moveNode(id, type, oldPosition, oldParent, newPosition, newParent)
		.subscribe(
			(id: any) => {
				console.log(id)
				this.jstreeUpdate()
			},
			(error: any) => {
				console.log(error)
				Swal.fire('Error', 'No se ha podido mover el nodo. Por favor, inténtelo de nuevo.', 'error')
			},
		)
	}

	editNode(node: any) {
		// console.log(node)
		let type = node.type
		let id = +node.id.split('_').pop()
		let name = node.text

		this.editNodeSub = this.dataService.editNode(id, type, name)
		.subscribe(
			(data: any) => {
				console.log(data)
				this.jstreeUpdate()
			},
			(error: any) => {
				console.log(error)
			},
		)
	}

	deleteNode(node: any) {
		// console.log(node)
		let type = node.type
		let id = +node.id.split('_').pop()
		let position = node.original.position
		let parent = +node.parent.split('_').pop()

		this.deleteNodeSub = this.dataService.deleteNode(id, type, position, parent)
		.subscribe(
			(data: any) => {
				console.log(data)
				this.jstreeUpdate()
				if (this.duplicate) this.showWelcome()
			},
			(error: any) => {
				console.log(error)
			},
		)
	}

	jstreeUpdate() {
		$(() => {
			let jstree = $('#jstree')
			jstree.jstree(true).settings!.core.data.url = this.treeDataUrl
			jstree.jstree(true).deselect_all()
			jstree.jstree(true).refresh(true)
		})
	}

	jstreeOpenAll() {
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).open_all()
			jstree.jstree(true).deselect_all()
		})
	}

	jstreeCloseAll() {
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).close_all()
			jstree.jstree(true).deselect_all()
		})
	}

	hideAll() {
		this.welcome = false
		this.search = false
		this.duplicate = false
		this.usersAdmin = false
		this.orgsAdmin = false
		this.userCoursePermissionsAdmin = false
	}

	courseSearch() {
		this.search = true
		// console.log(this.courseSearchTerm)
		if (this.courseSearchTerm == '') {
			Swal.fire('Error', 'Por favor, escriba algo en la caja de texto.', 'error')
			return
		}

		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).search(this.courseSearchTerm)
		})
	}

	clearSearch() {
		this.search = false
		this.courseSearchTerm = ''
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).clear_search()
		})
	}

	showWelcome() {
		this.hideAll()
		this.welcome = true
	}

	showDuplicate(type: string, id: number, name: string, parent: number) {
		this.hideAll()
		this.duplicate = true

		this.duplicateNodeType = type
		this.duplicateNodeId = id
		this.duplicateNodeName = name
		this.duplicateNodeParent = parent
	}

	showUserCoursePermissions(userID: any) {
		this.hideAll()
		this.userCoursePermissionsAdmin = true

		this.getUserCoursePermissionsSub = this.dataService.getUserCoursePermissions(userID)
		.subscribe(
			data => {
				console.log(data)
				this.userCoursePermissions = data
			},
			error => {
				console.log(error)
			},
		)

		return false
	}

	showOrgsAdmin() {
		this.hideAll()
		this.orgsAdmin = true
	}

	getOrgs(org: number = 0, role: number = 0) {
		this.getUsersSub = this.dataService.getUsers(org, role)
		.subscribe(
			users => {
				console.log(users)
				this.users = users
			},
			error => {
				console.log(error)
			},
		)
	}

	addOrg() {
		this.orgs.unshift({
			"id": 0,
			"name": "",
			"edit": true,
		})
	}

	toggleOrgEdit(org: any) {
		org.edit = true
		return false
	}

	editOrg(org: any) {
		// console.log(user)

		if (org.name == "") {
			Swal.fire('Error', 'Por favor, escriba un nombre para la nueva organización.', 'error')
			return false
		}

		/*
		org.edit = false
		this.editOrgSub = this.dataService.editOrganization(org)
		.subscribe(
			data => {
				console.log(data)
				this.getOrgs()
			},
			error => {
				console.log(error)
			},
		)
		*/

		return false
	}

}